import { useFormik } from "formik";
import * as Yup from "yup";
// import { getCities } from "countrycitystatejson";
import styled from "styled-components/macro";
import Emage from "../atoms/emage";
import Typography from "./typography";
import Input from "./Input";
import Button from "./Button";
import { NigerianStates } from "../utils/helpers";
import { useState } from "react";
import { sendToGoogleSheet } from "api/api";
import statesLGA from "utils/statesLGA";

const email_regex = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/;

const validationSchema = Yup.object().shape({
  fullname: Yup.string().min(3).required("Required"),
  email: Yup.string()
    .email()
    .min(3)
    .required("Required")
    .matches(email_regex, "invalid email"),
  phone: Yup.string().min(3).required("Required"),
  lga: Yup.string().required("Required"),
  state: Yup.string().required("Required"),
  referralCode: Yup.string().notRequired(),
});

interface IBecomeAnAgentForm {
  closeModal?: (state: boolean) => void;
}

export const BecomeAnAgentForm = ({ closeModal }: IBecomeAnAgentForm) => {
  const [isLoading, setIsLoading] = useState(false);
  const { values, handleChange, errors, handleSubmit, setFieldValue } =
    useFormik({
      initialValues: {
        fullname: "",
        email: "",
        phone: "",
        state: "",
        lga: "",
        referralCode: "",
      },
      enableReinitialize: true,
      onSubmit: async (values, { resetForm }) => {
        setIsLoading(true);
        await sendToGoogleSheet(values);
        resetForm({});
        setTimeout(() => {
          setIsLoading(false);
          closeModal && closeModal(false);
        }, 1000);
      },
      validationSchema,
    });

  // const cities = getCities("NG", values.state).sort();
  const cities =
    (statesLGA as { [index: string]: string[] })[values.state] || [];

  return (
    <Container>
      <div className="left">
        <div>
          <Typography.Heading
            color="pending"
            weight="medium"
            level={3}
            uppercase
            fontType="Galano"
          >
            START THE PROCESS
          </Typography.Heading>
          <Typography.Heading
            color="darkBlue"
            weight="medium"
            level={1}
            fontType="Galano"
          >
            Become an Agent
          </Typography.Heading>
        </div>
        <Emage />
      </div>
      <div className="right">
        <form onSubmit={handleSubmit}>
          <Input
            type="text"
            value={values.fullname}
            onChange={handleChange}
            name="fullname"
            label="Name"
            placeholder="Enter Your Name"
            error={errors.fullname}
          />
          <Input
            type="email"
            value={values.email}
            error={errors.email}
            onChange={handleChange}
            name="email"
            label="Email Address"
            placeholder="Enter your Email address"
          />
          <Input
            type="text"
            value={values.phone}
            error={errors.phone}
            onChange={handleChange}
            name="phone"
            label="Phone number"
            placeholder="Enter Your Phone number"
          />
          <Input.Select
            name="state"
            label="State"
            error={errors.state}
            options={[
              ...NigerianStates.map((state) => {
                return { value: state.code.toString(), label: state.state };
              }),
            ]}
            placeholder="Select state"
            onChange={({ target }) => {
              setFieldValue("state", target.value.label);
            }}
          />
          <Input.Select
            name="lga"
            error={errors.lga}
            onChange={({ target }) => {
              setFieldValue("lga", target.value.value);
            }}
            label="Local Government"
            options={cities.map((city) => ({ label: city, value: city }))}
            placeholder="Select LGA"
          />

          <Input
            type="text"
            value={values.referralCode}
            onChange={handleChange}
            name="referralCode"
            label="Referral Code"
            placeholder="Enter Referral Code"
            error={errors.referralCode}
          />

          <Button primary type="submit" fullWidth loading={isLoading}>
            <Typography.Text weight="medium" level="large">
              Submit
            </Typography.Text>
          </Button>
        </form>
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: 80vw;
  padding: 0 4em;

  @media screen and (max-width: 1100px) {
    padding: 0 2em;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
    height: auto;
    padding: 0 1em;
  }

  justify-content: space-between;
  height: 100%;
  overflow: hidden;
  .left {
    width: 40%;
    @media screen and (max-width: 1100px) {
      overflow-x: hidden;
    }
    @media screen and (max-width: 900px) {
      width: 30%;
    }

    @media screen and (max-width: 600px) {
      width: 100%;
      overflow-x: visible;
    }
  }
  .right {
    width: 40%;
    height: 100%;
    overflow: auto;
    @media screen and (max-width: 1100px) {
      width: 50%;
    }
    @media screen and (max-width: 600px) {
      width: 100%;
    }
    form {
      > * {
        margin-bottom: 1.3rem;
      }
    }
  }
`;
